const optimizeImage = (
  url: string,
  action: 'fixed' | 'crop' | 'min' | 'max',
  r: string,
  q: string,
): string => {
  if (!url || !url.includes('picsart.com')) {
    return url;
  }

  if (url.includes('.svg')) {
    return url;
  }

  const isWebP = url.includes('type=webp');
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  if (isWebP && isSafari) {
    return url.replace('type=webp', 'type=');
  }

  if (!isWebP && !url.includes('.gif')) {
    const type = 'type=webp';

    const qualityValue = q ? `&q=${q}` : '';
    const rValue = r ? `&r=${r}` : '&r=-1';
    const actionValue = action ? `&to=${action}${rValue}${qualityValue}` : '';
    return `${url}?${type}${actionValue}`;
  }

  return url;
};

export default optimizeImage;
